/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M5 6V6C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18V18M19 6V6C20.6569 6 22 7.34315 22 9V15C22 16.6569 20.6569 18 19 18V18M13 15C13 16.1046 12.1046 17 11 17C9.89543 17 9 16.1046 9 15C9 13.8954 9.89543 13 11 13C12.1046 13 13 13.8954 13 15ZM13 15V7L16 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="5"
				y="2"
				width="14"
				height="20"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19 8.4C19 6.15979 19 5.03969 18.564 4.18404C18.1805 3.43139 17.5686 2.81947 16.816 2.43597C15.9603 2 14.8402 2 12.6 2H11.4C9.15979 2 8.03969 2 7.18404 2.43597C6.43139 2.81947 5.81947 3.43139 5.43597 4.18404C5 5.03969 5 6.15979 5 8.4V15.6C5 17.8402 5 18.9603 5.43597 19.816C5.81947 20.5686 6.43139 21.1805 7.18404 21.564C8.03969 22 9.15979 22 11.4 22H12.6C14.8402 22 15.9603 22 16.816 21.564C17.5686 21.1805 18.1805 20.5686 18.564 19.816C19 18.9603 19 17.8402 19 15.6V8.4ZM11 17C12.1046 17 13 16.1046 13 15C13 13.8954 12.1046 13 11 13C9.89543 13 9 13.8954 9 15C9 16.1046 9.89543 17 11 17Z"
				fill="currentColor"
			/>
			<path
				d="M5 6V6C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18V18M19 6V6C20.6569 6 22 7.34315 22 9V15C22 16.6569 20.6569 18 19 18V18M13 15C13 16.1046 12.1046 17 11 17C9.89543 17 9 16.1046 9 15C9 13.8954 9.89543 13 11 13C12.1046 13 13 13.8954 13 15ZM13 15V7L16 9M11.4 22H12.6C14.8402 22 15.9603 22 16.816 21.564C17.5686 21.1805 18.1805 20.5686 18.564 19.816C19 18.9603 19 17.8402 19 15.6V8.4C19 6.15979 19 5.03968 18.564 4.18404C18.1805 3.43139 17.5686 2.81947 16.816 2.43597C15.9603 2 14.8402 2 12.6 2H11.4C9.15979 2 8.03968 2 7.18404 2.43597C6.43139 2.81947 5.81947 3.43139 5.43597 4.18404C5 5.03968 5 6.15979 5 8.4V15.6C5 17.8402 5 18.9603 5.43597 19.816C5.81947 20.5686 6.43139 21.1805 7.18404 21.564C8.03968 22 9.15979 22 11.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4 1.25H11.367C10.2749 1.24999 9.40936 1.24999 8.71173 1.30699C7.99834 1.36527 7.39472 1.48688 6.84354 1.76772C5.94978 2.22312 5.22312 2.94978 4.76772 3.84355C4.54167 4.28719 4.41879 4.76481 4.34905 5.3063C2.58826 5.61447 1.25 7.15095 1.25 9V15C1.25 16.849 2.58826 18.3855 4.34905 18.6937C4.41879 19.2352 4.54167 19.7128 4.76772 20.1565C5.22312 21.0502 5.94978 21.7769 6.84354 22.2323C7.39472 22.5131 7.99834 22.6347 8.71173 22.693C9.40935 22.75 10.2748 22.75 11.367 22.75H11.4H12.6H12.633C13.7252 22.75 14.5906 22.75 15.2883 22.693C16.0017 22.6347 16.6053 22.5131 17.1565 22.2323C18.0502 21.7769 18.7769 21.0502 19.2323 20.1565C19.4583 19.7128 19.5812 19.2352 19.651 18.6937C21.4117 18.3855 22.75 16.849 22.75 15V9C22.75 7.15095 21.4117 5.61447 19.651 5.3063C19.5812 4.76481 19.4583 4.28719 19.2323 3.84355C18.7769 2.94978 18.0502 2.22312 17.1565 1.76772C16.6053 1.48688 16.0017 1.36527 15.2883 1.30699C14.5906 1.24999 13.7251 1.24999 12.633 1.25H12.6H11.4ZM2.75 9C2.75 8.01758 3.37963 7.18222 4.25738 6.87544C4.24999 7.31964 4.25 7.81427 4.25 8.36694V8.36701V8.4V15.6V15.633C4.25 16.1857 4.24999 16.6803 4.25738 17.1246C3.37963 16.8178 2.75 15.9824 2.75 15V9ZM21.25 15C21.25 15.9824 20.6204 16.8178 19.7426 17.1246C19.75 16.6803 19.75 16.1857 19.75 15.633V15.6V8.4V8.36698C19.75 7.8143 19.75 7.31965 19.7426 6.87544C20.6204 7.18222 21.25 8.01758 21.25 9V15ZM12.6461 6.33874C12.89 6.20823 13.1859 6.22253 13.416 6.37596L16.416 8.37596C16.7607 8.60573 16.8538 9.07138 16.624 9.41603C16.3943 9.76067 15.9286 9.8538 15.584 9.62404L13.75 8.40139V15C13.75 16.5188 12.5188 17.75 11 17.75C9.48122 17.75 8.25 16.5188 8.25 15C8.25 13.4812 9.48122 12.25 11 12.25C11.4501 12.25 11.875 12.3581 12.25 12.5499V7C12.25 6.7234 12.4022 6.46926 12.6461 6.33874ZM12.25 15C12.25 14.3096 11.6904 13.75 11 13.75C10.3096 13.75 9.75 14.3096 9.75 15C9.75 15.6904 10.3096 16.25 11 16.25C11.6904 16.25 12.25 15.6904 12.25 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M5 6V6C3.34315 6 2 7.34315 2 9V9.5V10M5 18V18C3.34315 18 2 16.6569 2 15V14.5V14M19 6V6C20.6569 6 22 7.34315 22 9V9.5V10M19 18V18C20.6569 18 22 16.6569 22 15V14.5V14M13 15V7L16 9M13 15C13 16.1046 12.1046 17 11 17C9.89543 17 9 16.1046 9 15C9 13.8954 9.89543 13 11 13C12.1046 13 13 13.8954 13 15ZM11.4 22H12.6C14.8402 22 15.9603 22 16.816 21.564C17.5686 21.1805 18.1805 20.5686 18.564 19.816C19 18.9603 19 17.8402 19 15.6V8.4C19 6.15979 19 5.03968 18.564 4.18404C18.1805 3.43139 17.5686 2.81947 16.816 2.43597C15.9603 2 14.8402 2 12.6 2H11.4C9.15979 2 8.03968 2 7.18404 2.43597C6.43139 2.81947 5.81947 3.43139 5.43597 4.18404C5 5.03968 5 6.15979 5 8.4V15.6C5 17.8402 5 18.9603 5.43597 19.816C5.81947 20.5686 6.43139 21.1805 7.18404 21.564C8.03968 22 9.15979 22 11.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M5 6V6C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18V18M19 6V6C20.6569 6 22 7.34315 22 9V15C22 16.6569 20.6569 18 19 18V18M13 15C13 16.1046 12.1046 17 11 17C9.89543 17 9 16.1046 9 15C9 13.8954 9.89543 13 11 13C12.1046 13 13 13.8954 13 15ZM13 15V7L16 9M11.4 22H12.6C14.8402 22 15.9603 22 16.816 21.564C17.5686 21.1805 18.1805 20.5686 18.564 19.816C19 18.9603 19 17.8402 19 15.6V8.4C19 6.15979 19 5.03968 18.564 4.18404C18.1805 3.43139 17.5686 2.81947 16.816 2.43597C15.9603 2 14.8402 2 12.6 2H11.4C9.15979 2 8.03968 2 7.18404 2.43597C6.43139 2.81947 5.81947 3.43139 5.43597 4.18404C5 5.03968 5 6.15979 5 8.4V15.6C5 17.8402 5 18.9603 5.43597 19.816C5.81947 20.5686 6.43139 21.1805 7.18404 21.564C8.03968 22 9.15979 22 11.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.45 1.25C8.92976 1.25 7.66965 1.25 6.70704 1.74047C5.86031 2.1719 5.1719 2.86031 4.74047 3.70704C4.25 4.66965 4.25 5.92976 4.25 8.45V15.55C4.25 18.0702 4.25 19.3304 4.74047 20.293C5.1719 21.1397 5.86031 21.8281 6.70704 22.2595C7.66965 22.75 8.92976 22.75 11.45 22.75H12.55C15.0702 22.75 16.3304 22.75 17.293 22.2595C18.1397 21.8281 18.8281 21.1397 19.2595 20.293C19.75 19.3304 19.75 18.0702 19.75 15.55V8.45C19.75 5.92976 19.75 4.66965 19.2595 3.70704C18.8281 2.86031 18.1397 2.1719 17.293 1.74047C16.3304 1.25 15.0702 1.25 12.55 1.25H11.45Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 9.25V14.75C1 16.5449 2.45507 18 4.25 18V6C2.45507 6 1 7.45507 1 9.25ZM23 9.25V14.75C23 16.5449 21.5449 18 19.75 18V6C21.5449 6 23 7.45507 23 9.25ZM12.6461 6.33874C12.89 6.20823 13.1859 6.22253 13.416 6.37596L16.416 8.37596C16.7607 8.60573 16.8538 9.07138 16.624 9.41603C16.3943 9.76067 15.9286 9.8538 15.584 9.62404L13.75 8.40139V15C13.75 16.5188 12.5188 17.75 11 17.75C9.48122 17.75 8.25 16.5188 8.25 15C8.25 13.4812 9.48122 12.25 11 12.25C11.4501 12.25 11.875 12.3581 12.25 12.5499V7C12.25 6.7234 12.4022 6.46926 12.6461 6.33874ZM12.25 15C12.25 14.3096 11.6904 13.75 11 13.75C10.3096 13.75 9.75 14.3096 9.75 15C9.75 15.6904 10.3096 16.25 11 16.25C11.6904 16.25 12.25 15.6904 12.25 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
